import { Component, OnInit, Input, SimpleChanges
       } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { Observable } from 'rxjs';
import { StateInteractionService } from 'angular-engine/engine/service/dynamic/state.interaction.service';
import { UtilService } from 'angular-engine/engine/service/util/util.service';
import { DataService } from "angular-engine/engine/service/data/api.data.service";
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Rows } from '../../components/rows/rows.component';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';

@Component({
  selector: 'grid-container',
  templateUrl: './grid-container.component.html',
  styleUrls: ['./grid-container.style.scss']
})
export class GridContainer extends StaticContainer  {

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/grid-container/grid-container.component.ts